export const ALE_2022 = {
    phase: 'slutlig',
    totalSeats: 49,
    validVotes: 19534,
    invalidVotes: 315,
    eligibleVoters: 24262,
    turnoutPct: 81.81,
    parties: [
        { code: 'S', votes: 5719, seats: 14 },
        { code: 'SD', votes: 4050, seats: 10 },
        { code: 'M', votes: 4011, seats: 10 },
        { code: 'V', votes: 1508, seats: 4 },
        { code: 'C', votes: 1020, seats: 3 },
        { code: 'KD', votes: 1020, seats: 3 },
        { code: 'FiA', votes: 879, seats: 2 },
        { code: 'L', votes: 618, seats: 2 },
        { code: 'MP', votes: 500, seats: 1 },
    ],
};
export const ALE_2022_VOTES_BY_CODE = Object.fromEntries(ALE_2022.parties.map((p) => [p.code, p.votes]));
export const ALE_2022_SEATS_BY_CODE = Object.fromEntries(ALE_2022.parties.map((p) => [p.code, p.seats]));
//# sourceMappingURL=ale-2022.js.map